import { render } from "./AgentePicker.vue?vue&type=template&id=09b3f610"
import script from "./AgentePicker.vue?vue&type=script&lang=ts"
export * from "./AgentePicker.vue?vue&type=script&lang=ts"
script.render = render

export default script